import { centsToDollar } from '@givebacks/utils/currency';
import { ButtonProps, CardProps, Text } from 'ui';

import { InformationCard } from './InformationCard';

type TotalDueCardProps = {
  totalDue?: number;
  radius?: CardProps['radius'];
  withPayNowButton?: boolean;
  buttonProps?: ButtonProps & { onClick?: () => void };
};

const TotalDueText = ({ totalDue = 0 }: { totalDue?: number }) => {
  return (
    <Text type="sub" fw={400} c="white">
      Total Due:{' '}
      <Text type="sub" fw={600} c="white" span>
        {centsToDollar(totalDue)}
      </Text>
    </Text>
  );
};

const TotalDueCard = ({
  totalDue,
  radius = 'md',
  withPayNowButton = true,
  buttonProps,
}: TotalDueCardProps) => {
  return (
    <InformationCard
      text={<TotalDueText totalDue={totalDue} />}
      buttonProps={{ children: 'Pay Now', ...buttonProps }}
      isButtonVisible={!!totalDue && withPayNowButton}
      radius={radius}
    />
  );
};

export { TotalDueCard };
